import { inject, Injectable } from '@angular/core';
import { takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { AuthenticationService } from '~/core/services/authentication.service';
import { CompanyStore } from '~/core/store/company.store';
import { BetSafeService } from '~/core/services/betsafe.service';
import { PendingActionsService } from '~/core/services/pending-actions.service';
import { DestroyService } from '~/core/services/destroy.service';
import { CompanyService } from '~/core/services/company.service';
import { LicenseService } from '~/core/services/license.service';

@Injectable({
  providedIn: 'root',
})
export class LoadSecondaryService {
  private auth = inject(AuthenticationService);
  private readonly companyStore = inject(CompanyStore);
  private companyService = inject(CompanyService);
  private readonly betSafeService = inject(BetSafeService);
  private pendingActionsService = inject(PendingActionsService);
  private readonly destroy$ = inject(DestroyService);
  private dialog = inject(MatDialog);
  private licenseService = inject(LicenseService);

  loadSecondaryServices() {
    this.betSafeService.setBetSafe();
    this.recheckVerificationAlerts();
    this.licenseService.setLicense();
  }

  recheckVerificationAlerts() {
    this.pendingActionsService.pendingActionsUpdate.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (AuthenticationService.currentUser?.pending_actions) {
        this.auth.updateAlerts();
      }
    });
  }

  showGuestDepositModal() {
    if (!this.auth.isLoggedIn() && this.companyService.isEnabledGuestPlayers) {
      import('~/components/deposit-pix-plus2/guest-user-pix-desktop-plus2/guest-user-pix-desktop-plus2.component').then(
        ({ GuestUserPixDesktopPlus2Component }) => {
          this.dialog.open(GuestUserPixDesktopPlus2Component, {
            disableClose: true,
            width: '480px',
          });
        },
      );
    }
  }
}
